<div class="mdc-form-field">

    <div class="mdc-radio" ref="radioElm">

        <input type="radio" class="mdc-radio__native-control" :id="id" ref="native"
            :checked="checked" :disabled="disabled" :name="name" :value="value"
            @change="onInput" />

        <div class="mdc-radio__background">
            <div class="mdc-radio__outer-circle"></div>
            <div class="mdc-radio__inner-circle"></div>
        </div>
    </div>

    <label class="mdc-radio__label" :for="id"><slot></slot></label>

</div>
